(() => {
  let frame = 0;
  const sync = () => {
    frame = 0;
    const visible = Array.from(document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs__dialog')).some(element => {
      const style = getComputedStyle(element);
      return !element.hidden && element.getAttribute('aria-hidden') !== 'true' && style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
    });
    if (document.documentElement.classList.contains('sgp-consent-open') !== visible) {
      document.documentElement.classList.toggle('sgp-consent-open', visible);
    }
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
  const boot = () => {
    sync();
    new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['hidden','style','class','aria-hidden','open']});
    window.addEventListener('resize', schedule, {passive:true});
    document.addEventListener('visitorConsentCollected', schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
})();
